export default function (props: any) {
    return (
        <svg width="39px" height="38px" viewBox="0 0 39 38" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="DELTA-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="phone_icon" transform="translate(0.983755, 0.000000)">
                    <rect id="矩形" x="0" y="0" width="38" height="38"></rect>
                    <g id="编组-63" transform="translate(9.119710, 2.756133)" stroke="#FFFFFF">
                        <circle id="椭圆形" strokeWidth="0.669850187" fill="#FFFFFF" cx="9.88029026" cy="27.7738074" r="1.26693922"></circle>
                        <line
                            x1="7.91842979"
                            y1="3.72548405"
                            x2="11.8421507"
                            y2="3.72548405"
                            id="路径-3"
                            strokeWidth="1.13874532"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                        <rect id="矩形" strokeWidth="1.13874532" x="0.569372659" y="0.569372659" width="18.6218352" height="31.3489888" rx="3.34925094"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
}
